import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import PageShell from '../Components/ui/PageShell';
import { changePasswordLoggedIn } from '../services/authService';
import { showError, showSuccess } from '../utils/toast';

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (newPassword.length < 6) {
      showError('New password must be at least 6 characters long.');
      return;
    }

    if (newPassword !== confirmPassword) {
      showError('New password and confirm password do not match.');
      return;
    }

    setLoading(true);
    try {
      await changePasswordLoggedIn(currentPassword, newPassword);
      setCompleted(true);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      showSuccess('Password changed successfully.');
    } catch (error) {
      showError(error.message || 'Unable to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell
      title="Change Password"
      subtitle="Update your account password while signed in."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Settings', path: '/settings' },
        { label: 'Change Password' },
      ]}
      backTo="/settings"
    >
      <div className="hr-card" style={{ maxWidth: '520px', padding: '24px' }}>
        {completed ? (
          <div>
            <p className="mb-3">Your password has been updated.</p>
            <Link to="/settings" className="hr-login-link">Back to Settings</Link>
          </div>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="currentPassword">
              <Form.Label><b>Current Password</b></Form.Label>
              <Form.Control
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label><b>New Password</b></Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                minLength={6}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="confirmPassword">
              <Form.Label><b>Confirm New Password</b></Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                minLength={6}
                required
              />
            </Form.Group>

            <div className="d-flex gap-2 flex-wrap">
              <Button type="submit" className="hr-btn-primary" disabled={loading}>
                {loading ? 'Updating...' : 'Update Password'}
              </Button>
              <Button as={Link} to="/forgotpassword" variant="outline-secondary">
                Forgot current password?
              </Button>
            </div>
          </Form>
        )}
      </div>
    </PageShell>
  );
}

export default ChangePassword;
